import i18n from 'i18next';

export const languageDetectorMiddleware = ({ dispatch, getState }) => next => action => {
	if (action.type === 'persist/REHYDRATE') {
		const { payload } = action;
		if (payload && payload.language) i18n.changeLanguage(payload.language);
	}
	return next(action);
};

